import { Skeleton } from '@common/components';
import { cn } from '@core/utils';
import { useState } from 'react';

import { Image } from '@/components/client';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface DesktopMainImagesProps {
  title: string;
  heroImageUrlList: string[];
  adultYN: boolean;
}

export const DesktopMainImages = ({
  title,
  heroImageUrlList,
  adultYN,
}: DesktopMainImagesProps) => {
  //* SSR 및 초기 렌더링 시 모바일로 가정하여 모바일일 때 초기 이미지 로딩 방지
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState<Set<number>>(new Set([0]));

  const handleImageSelect = (index: number) => {
    setSelectedImageIndex(index);
  };

  const handleImageLoad = (index: number) => {
    setLoadedImages((prev) => new Set(prev).add(index));
  };

  const isCurrentImageLoaded = loadedImages.has(selectedImageIndex);

  return (
    <div className="mobile:hidden tablet:hidden">
      <div className="relative mb-20 aspect-square">
        {/* 모바일에서는 요청하지 않도록 */}
        {isDesktopViewport ? (
          <>
            {!isCurrentImageLoaded && (
              <Skeleton className="absolute inset-0 size-full rounded-[48px]" />
            )}
            <div className="relative size-full rounded-[48px]">
              <Image
                key={selectedImageIndex}
                fill
                preload
                alt={title || '웰로 고향사랑기부 답례품'}
                src={heroImageUrlList[selectedImageIndex]}
                sizes="(min-width: 1280px) 50vw"
                className={cn(
                  'rounded-[48px] object-cover object-center transition-opacity duration-200',
                  !isCurrentImageLoaded && 'opacity-0',
                )}
                onLoad={() => handleImageLoad(selectedImageIndex)}
              />
            </div>
          </>
        ) : (
          <Skeleton className="size-full rounded-[48px]" />
        )}
        {adultYN && (
          <div className="absolute left-20 top-20 rounded-xsmall bg-B-500 px-12 py-4 font-600 text-Gray-white typo-body4">
            19세이상 구매가능
          </div>
        )}
      </div>
      <div className="grid grid-cols-6 gap-10">
        {heroImageUrlList.map((imageUrl, index) => (
          <div
            key={index}
            className={cn('relative aspect-square w-full cursor-pointer overflow-hidden rounded-large', {
              'border-1 border-Gray-black': selectedImageIndex === index,
            })}
            onClick={() => handleImageSelect(index)}
          >
            <Image
              fill
              loading="lazy"
              src={imageUrl}
              alt={title || '웰로 고향사랑기부 답례품'}
              sizes="(min-width: 1280px) 8vw"
              className="object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
